import { render, staticRenderFns } from "./details.vue?vue&type=template&id=4e1c601d&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=4e1c601d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c601d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1c601d')) {
      api.createRecord('4e1c601d', component.options)
    } else {
      api.reload('4e1c601d', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=4e1c601d&scoped=true", function () {
      api.rerender('4e1c601d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/approveAnnual/details.vue"
export default component.exports